import { AO_ORIGIN_ADDRESS_DETAILS_FAILURE, AO_ORIGIN_ADDRESS_DETAILS_REQUEST, AO_ORIGIN_ADDRESS_DETAILS_SUCCESS, AO_SEND_ADDRESS_DETAILS_FAILURE, AO_SEND_ADDRESS_DETAILS_REQUEST, AO_SEND_ADDRESS_DETAILS_SUCCESS, AO_RETURN_ADDRESS_DETAILS_FAILURE, AO_RETURN_ADDRESS_DETAILS_REQUEST, AO_RETURN_ADDRESS_DETAILS_SUCCESS } from "../../actions";
const initialState = {
    originAddress: null,
    destinationAddress: null,
    returnAddress: null,
    loading: false,
    error: null,
};
const addOrderAddressDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        // Destination Address
        case AO_SEND_ADDRESS_DETAILS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, destinationAddress: action.payload });
        case AO_SEND_ADDRESS_DETAILS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, destinationAddress: action.payload, error: null });
        case AO_SEND_ADDRESS_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        // Origin Address 
        case AO_ORIGIN_ADDRESS_DETAILS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, originAddress: action.payload });
        case AO_ORIGIN_ADDRESS_DETAILS_SUCCESS:
            return Object.assign(Object.assign({}, state), { originAddress: action.payload, isLoading: false, error: null });
        case AO_ORIGIN_ADDRESS_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        // Return Address 
        case AO_RETURN_ADDRESS_DETAILS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, returnAddress: action.payload });
        case AO_RETURN_ADDRESS_DETAILS_SUCCESS:
            return Object.assign(Object.assign({}, state), { returnAddress: action.payload, isLoading: false, error: null });
        case AO_RETURN_ADDRESS_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        default:
            return state;
    }
};
export default addOrderAddressDetailsReducer;
